import { Button, Flex, Popover, PopoverProps } from "antd";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MaxAllowedFreeCharts } from "../../constants";

interface SubscriptionPopoverProps {
  children: ReactNode;
  chartsCount: number;
  placement?: PopoverProps["placement"];
  showSubscribeButton?: boolean;
}

const SubscriptionPopover = ({
  children,
  chartsCount,
  placement = "bottomLeft",
  showSubscribeButton = true,
}: SubscriptionPopoverProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const remainingCharts = MaxAllowedFreeCharts - chartsCount;
  
  return (
    <Popover
      placement={placement}
      title={t("only_x_charts_left", {
        count: remainingCharts,
      })}
      content={
        <Flex vertical gap={8}>
          <p>{t("to_create_unlimited_charts")}</p>
          {showSubscribeButton && (
            <Button
              type="primary"
              onClick={() => {
                setOpen(false);
                navigate("/subscription");
              }}
            >
              {t("subscribe_now")}
            </Button>
          )}
        </Flex>
      }
      open={open}
      onOpenChange={setOpen}
    >
      {children}
    </Popover>
  );
};

export default SubscriptionPopover;